export const COUNTRY_VARIABLES = {
    countryCode: "",
  };
  